import { render, staticRenderFns } from "./Mocks.vue?vue&type=template&id=46a0f8c9&scoped=true&"
import script from "./Mocks.vue?vue&type=script&lang=js&"
export * from "./Mocks.vue?vue&type=script&lang=js&"
import style0 from "./Mocks.vue?vue&type=style&index=0&id=46a0f8c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a0f8c9",
  null
  
)

export default component.exports